module.exports = __webpack_public_path__ + "img/admin.9df838ba.svg";